import { gql } from "@apollo/client";

const getChatSessionsForAssessmentQuery = gql`
  query getChatSessionsForAssessmentQuery($assessmentId: Int!) {
    chatSessions(assessmentId: $assessmentId) {
      edges {
        node {
          id
          assessmentQuestionId
        }
      }
    }
  }
`;

export default getChatSessionsForAssessmentQuery;
